function waitForjQuery(trigger) {
  var interval = setInterval(function () {
    if (window.jQuery !== undefined) {
      clearInterval(interval);
      trigger(window.jQuery);
    }
  }, 50);
  setTimeout(function () {
    clearInterval(interval);
  }, 15000);
}
// Before after effect
waitForjQuery(function () {
  $(document).ready(function () {
    // Search functionality for faq
    $(".search-box-wrapper input").on("keyup", function () {
      var input = $(this);
      if (input.val().length > 1) {
        $(".page-product-tab,.faqs-sidebar,.faqs-block-title").hide();
        const input_text = $.trim(input.val());
        console.log('input',input_text);
        $(".faqs-content").each(function () {
          const question_text = $(this).find(".faqs-question p").text();
          const answer_text = $(this)
            .find(".faqs-answer")
            .html()
            .replace(/(<([^>]+)>)/gi, "");
          console.log(question_text);
          console.log(answer_text);
          if (
            question_text.indexOf(input_text) > -1 ||
            answer_text.indexOf(input_text) > -1
          ) {
            $(this).show();
          } else {
            $(this).hide();
          }
        });
      } else {
        $(
          ".page-product-tab,.faqs-sidebar,.faqs-block-title,.faqs-content"
        ).show();
      }
    });
    // FAQ page content load
    function load_faq_sidebar() {
      let content = "";
      let ul_content = "";
      $(".faqs-container .faqs-block-title").each(function () {
        const faq_sub_heading = $(this).attr("id");
        const SplitTitles = [];
        const titleText = $(this).text();
        const faq_text = (SplitTitles.includes(titleText)) ? titleText.split(" ")[0] : titleText;
        console.log('Faq_text',$(this).text())
        ul_content += `<li data-faq-title="${faq_sub_heading}">${faq_text}</li>`;
      });
       console.log('Ul_Content',ul_content)
      $(".product__tab-wrapper .product__tab").each(function () {
        const faq_title = $(this).data("sidebar-title");
        const faq_link = $(this).data("page-handle");
        const has_active_class = $(this).hasClass("active") || "";
        let active_class_data = "";
        if (has_active_class) {
          active_class_data = `<div class="sidebar-block ${
            has_active_class ? "active" : ""
          }">
        <p>${faq_title}</p>
        <ul>${ul_content}</ul>
      </div>`;
        } else {
          active_class_data = `<div class="sidebar-block"><p data-tag="${faq_link}">${faq_title}</p></div>`;
        }
        content += active_class_data;
      });
      $(".faqs-sidebar .sidebar-blocks").html(content);
    }
   
    load_faq_sidebar();
    $(document).on(
      "click",
      ".faqs-quenstion-wrapper .faqs-question",
      function () {
        const parent_node = $(this).closest(".faqs-content");
        parent_node.siblings().removeClass("active");
        parent_node.siblings().find(".faqs-answer").slideUp();
        parent_node.addClass("active");
        parent_node.find(".faqs-answer").slideToggle();
      }
    );
    // li tab click functionality
    $(document).on("click", ".sidebar-block ul li", function () {
      const heading_title = $(this).attr("data-faq-title");
      console.log("heading_title",heading_title);
      $("html, body").animate({
        scrollTop: $("#" + heading_title).position().top,
      });
    });
    $(document).on("click", ".sidebar-block p", function () {
      const heading_title = $(this).attr("data-tag");
      $('.product__tab[data-page-handle="' + heading_title + '"]').trigger(
        "click"
      );
    });
    /******************** How to use ajax load ************************/
    function get_page_content(responce_html) {
      // console.log('Page content',responce_html);
      // Get content
      const download_instruction_section_content = responce_html
        .find(".product-instructions")
        .html();
      const title_section_content = responce_html
        .find(".how-to-use-page-title")
        .html();
      const product_feature_section_content = responce_html
        .find(".how-to-use-product-feature")
        .html();
      const real_face_real_result_content = responce_html
        .find(".real_face-content-wrapper")
        .html();
      const real_face_real_result__before_image = responce_html
        .find(".real_face-image-wrapper #r_a_before")
        .attr("data-src");
      const real_face_real_result__after_image = responce_html
        .find(".real_face-image-wrapper #r_a_after")
        .attr("data-src");
      const real_face_image_position = responce_html
        .find(".real_face-content-section")
        .attr("data-image-position");
      const best_result_content = responce_html
        .find(".how-to-use-text-block")
        .html();
      const scroll_text_content = responce_html
        .find(".collection-scroll-section")
        .html();
      const review_section_content = responce_html
        .find(".how-to-use-page-review")
        .html();
      const faq_section_content = responce_html
        .find(".faq-section-static")
        .html();

      const product_video_section = responce_html
        .find(".how-to-use-product-videos")
        .html();
       console.log('Page content',responce_html);
      console.log(
        real_face_real_result__before_image,
        real_face_real_result__after_image
      );
      // Update content
      $(".product-instructions").html(download_instruction_section_content);
      $(".how-to-use-page-title").html(title_section_content);
      $(".how-to-use-product-feature").html(product_feature_section_content);
      
      $(".how-to-use-product-videos").html(product_video_section);
      
      $(".real_face_container .real_face-content-wrapper").html(
        real_face_real_result_content
      );
      $(".real_face-image-wrapper #r_a_before").css(
        "background-image",
        "url(" + real_face_real_result__before_image + ")"
      );
      $(".real_face-image-wrapper #r_a_after").css(
        "background-image",
        "url(" + real_face_real_result__after_image + ")"
      );
      $(".real_face-content-section").attr(
        "data-image-position",
        real_face_image_position
      );
      $(".how-to-use-text-block").html(best_result_content);
      $(".collection-scroll-section").html(scroll_text_content);
      $(".how-to-use-page-review").html(review_section_content);
      $(".faq-section-static").html(faq_section_content);
      // Stamp review update
      // StampedFn.reloadUGC();
      // update FAQ page content
      const faq_main_content = responce_html
        .find(".faqs-sidebar-wrapper .faqs-container")
        .html();
      const faq_sidebar_content = responce_html
        .find(".faqs-sidebar-wrapper .faqs-sidebar")
        .html();
      $(".faqs-sidebar-wrapper .faqs-sidebar").html(faq_sidebar_content);
      $(".faqs-sidebar-wrapper .faqs-container").html(faq_main_content);
      load_faq_sidebar();
    }
    $(".page-product-tab .product__tab").on("click", function () {
      const window_location = window.location.href;
      console.log('window location:',window_location);
      const _this = $(this);
      const page_handle = $(this).closest(".product__tab").data("page-handle");
      const session_data = sessionStorage.getItem(page_handle);
      if (window_location.indexOf(page_handle) > -1) {
        return false;
      }
      
      var headerHtml = $(".collection__header-text .h2-title").html();

      if (headerHtml) {
         if (headerHtml.includes("NIRA Pro")) {
          $(".collection__header-text .h2-title").html(headerHtml.replace("NIRA Pro", "NIRA Precision"));
        } else if (headerHtml.includes("NIRA Precision")) {
          $(".collection__header-text .h2-title").html(headerHtml.replace("NIRA Precision", "NIRA Pro"));
        }
      }
      
      history.pushState({}, null, `/pages/${page_handle}`);
      if (session_data) {
        $(".page-product-tab  .product__tab").removeClass("active");
        _this.addClass("active");
        get_page_content($($.parseHTML(session_data)));
        return false;
      }

      $.ajax({
        url: `/pages/${page_handle}`,
        type: "get",
        async: false,
        success: function (html) {
          $(".page-product-tab .product__tab").removeClass("active");
          _this.addClass("active");
          const responce_html = $($.parseHTML(html));
          //Add page content to session
          try {
            sessionStorage.setItem(page_handle, html);
          } catch {
            sessionStorage.clear();
            sessionStorage.setItem(page_handle, html);
          }
          
          // Get page content
          get_page_content(responce_html);
        },
        error: function (jqXHR, exception) {
          console.log(jqXHR, exception);
        },
      });
    });
    /******************** How to use ajax load end ************************/
    // Popup video code
    $(document).on("click", ".product-features .feature-button", function (e) {
      e.preventDefault();
      $(".featured-video-popup").addClass("active");
    });
    $(document).on(
      "click",
      ".popup-video-wrapper .close-popup-button",
      function () {
        $(".featured-video-popup").removeClass("active");
      }
    );

    $(document).on("click", ".popup-video-wrapper .video-icon", function(e) {
        console.log("clicked");
        const _this = $(".popup-video-wrapper video").get(0);
        _this.paused ? _this.play() : _this.pause();
        _this.paused
          ? $(".popup-video-wrapper .video-icon").show()
          : $(".popup-video-wrapper .video-icon").hide();
    });

    $(document).on("click", ".popup-video-wrapper video", function(e) {
        console.log("clicked");
        const _this = $(".popup-video-wrapper video").get(0);
        _this.paused ? _this.play() : _this.pause();
        _this.paused
          ? $(".popup-video-wrapper .video-icon").show()
          : $(".popup-video-wrapper .video-icon").hide();
    });

    $(document).on("click", ".featured-video-popup", function(e) {

        $(".featured-video-popup").removeClass("active");
      
        var iframe = document.querySelector('iframe');
   
    	if ( iframe ) {
    		var iframeSrc = iframe.src;
    		iframe.src = iframeSrc;
    	}
    });

  });
});
